<div class="separator"></div>

<div class="row form-row align-items-center">
    <div class="col"><h3 class="page-subheader" [class.pb-0]="hasRemoveInsured" *ngIf="title">{{ title }}</h3>
    </div>
    <div class="col-size">
        <button class="btn btn-link btn-slim"
                (click)="remove()"
                *ngIf="hasRemoveInsured">
            <i class="icon-remove mr-2"></i>
            <span>{{'BUTTON.REMOVE_INSURED' | translate}}</span>
        </button>
    </div>
</div>

<ng-container *ngIf="companyAllowed">

    <div class="row form-row">
        <div class="col-4">
            <app-select
                    [(ngModel)]="party.typeCode"
                    [hasEmpty]="false"
                    [label]="'LABEL.PARTY_TYPE' | translate"
                    [itemList]="(dictionaries$|async)[dictionaryTypes.PARTY_TYPE].itemList"
                    [errorStateMatcher]="matchers.typeCode">
            </app-select>
        </div>
    </div>

</ng-container>

<ng-container *ngIf="party.typeCode === partyTypes.LEGAL">
    <div class="row form-row">
        <div class="col-4">
            <app-input
                    [(ngModel)]="party.companyName"
                    [errorStateMatcher]="matchers.companyName"
                    [label]="'LABEL.COMPANY_NAME' | translate">
            </app-input>
        </div>

        <div class="col-4">
            <app-input
                    [(ngModel)]="party.companyNumber"
                    [errorStateMatcher]="matchers.companyNumber"
                    [label]="'LABEL.COMPANY_NUMBER' | translate">
            </app-input>
        </div>

        <div class="col-4">
            <app-select
                    [ngModel]="party.companyCountry?.code"
                    [label]="'LABEL.COMPANY_COUNTRY' | translate"
                    (ngModelChange)="party.companyCountry = {code: $event}"
                    [hasEmpty]="false"
                    [itemList]="(dictionaries$|async)[dictionaryTypes.COUNTRY].itemList"
                    [errorStateMatcher]="matchers.companyCountry">
            </app-select>
        </div>
    </div>

    <app-address-form [title]="'LABEL.ADDRESS_CORESPONDENCE' | translate"
                      [address]="party.mainAddress"
                      [aside]="aside"
                      [allowForeign]="allowForeignAddress"
                      [prefix]="prefix ? prefix + '.mainAddress' : 'mainAddress'">
    </app-address-form>

</ng-container>

<ng-container *ngIf="party.typeCode === partyTypes.NATURAL">
    <div class="row form-row">
        <div class="col-4">
            <app-input
                    [(ngModel)]="party.firstName"
                    [errorStateMatcher]="matchers.firstName"
                    [label]="'LABEL.NAME' | translate">
            </app-input>
        </div>

        <div class="col-4">
            <app-input
                    [(ngModel)]="party.lastName"
                    [errorStateMatcher]="matchers.lastName"
                    [label]="'LABEL.SURNAME' | translate">
            </app-input>
        </div>

        <div class="col-4">
            <app-input
                    [(ngModel)]="party.maidenName"
                    [errorStateMatcher]="matchers.maidenName"
                    [label]="'LABEL.FAMILY_NAME' | translate">
            </app-input>
        </div>
    </div>

    <div class="row form-row">
        <div class="col-4">
            <app-numpad
                    [disabled]="blockPeselForForeigner && party.foreigner"
                    [(ngModel)]="party.pesel"
                    [errorStateMatcher]="matchers.pesel"
                    [config]="{maxlength: 11, allowLeadingZeros: true}"
                    [label]="'LABEL.PESEL' | translate">
            </app-numpad>
        </div>
    </div>

    <div class="row form-row">
        <div class="col-4 form-label-static">
            <mat-checkbox [ngModel]="party.foreigner" (ngModelChange)="foreigner = $event">
                {{ noPeselLabel | translate }}
            </mat-checkbox>

            <app-errors [errorStateMatcher]="matchers.foreigner"></app-errors>
        </div>
    </div>

    <div class="row form-row" *ngIf="matchers.frontier.errors.length > 0">
        <div class="col-4">
            <app-errors [errorStateMatcher]="matchers.frontier"></app-errors>
            <div class="separator"></div>
        </div>
    </div>

    <!-- no pesel-->
    <div *ngIf="party.foreigner">
        <div class="row form-row">
            <div class="col-4">
                <app-select
                        [ngModel]="party.citizenship?.code"
                        (ngModelChange)="party.citizenship = {code: $event}"
                        [label]="'LABEL.CITIZENSHIP' | translate"
                        [errorStateMatcher]="matchers.citizenship"
                        [itemList]="(dictionaries$ | async)[dictionaryTypes.NATIONALITY].itemList">
                </app-select>
            </div>
        </div>

        <div class="row form-row">
            <div class="col-4">
                <app-datepicker
                        [(ngModel)]="party.birthDate"
                        [label]="'LABEL.DATE_OF_BIRTH' | translate"
                        [errorStateMatcher]="matchers.birthDate">
                </app-datepicker>
            </div>
        </div>

        <div class="row form-row">
            <div class="col-4">
                <app-select
                        [ngModel]="party.gender?.code"
                        (ngModelChange)="party.gender = {code: $event}"
                        [label]="'LABEL.GENDER' | translate"
                        [errorStateMatcher]="matchers.gender"
                        [itemList]="(dictionaries$ | async)[dictionaryTypes.GENDER].itemList">
                </app-select>
            </div>
        </div>

        <div class="row form-row">
            <div class="col-4">
                <app-select
                        [ngModel]="party.documentType?.code"
                        (ngModelChange)="party.documentType = {code: $event}"
                        [label]="'LABEL.DOCUMENT_TYPE' | translate"
                        [errorStateMatcher]="matchers.documentType"
                        [itemList]="(dictionaries$ | async)[dictionaryTypes.DOCUMENT_TYPE].itemList">
                </app-select>
            </div>

            <div class="col-4">
                <app-input
                        [(ngModel)]="party.documentNumber"
                        [errorStateMatcher]="matchers.documentNumber"
                        [label]="'LABEL.DOCUMENT_NUMBER' | translate">
                </app-input>
            </div>
        </div>
    </div>


    <div class="separator"></div>

    <!--    address zamieszkania-->
    <div>
        <app-address-form [title]="'LABEL.ADDRESS' | translate"
                          [address]="party.mainAddress"
                          [aside]="aside"
                          [allowForeign]="allowForeignAddress"
                          [prefix]="prefix ? prefix + '.mainAddress' : 'mainAddress'">
        </app-address-form>
    </div>


    <!--    address korespondencyjny -->
    <div class="row form-row">
        <div class="col form-label-static">
            <mat-checkbox [(ngModel)]="party.otherCorrespondenceAddress">
                {{'LABEL.DIFFERENT_CORRESPONDENCE_ADDRESS' | translate}}
            </mat-checkbox>
        </div>
    </div>

    <div *ngIf="party.otherCorrespondenceAddress">

        <div class="separator"></div>

        <app-address-form [title]="'LABEL.ADDRESS_CORESPONDENCE' | translate"
                          [address]="party.correspondenceAddress"
                          [aside]="aside"
                          [allowForeign]="allowForeignAddress"
                          [prefix]="prefix ? prefix + '.correspondenceAddress' : 'correspondenceAddress'">
        </app-address-form>
    </div>
</ng-container>
